import CommandKeyIcon from '../../icons/CommandKeyIcon.svg?react';
import CornerDownLeftIcon from '../../icons/CornerDownLeftIcon.svg?react';

export interface Hotkey {
  keys: string[] | JSX.Element[];
  description: string;
  interjection?: string;
}

const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);

const annotations_queue = [
  {
    keys: ['N'],
    description: 'Add a note',
  },
  {
    keys: ['T'],
    description: 'Add a tag',
  },
  {
    keys: ['V'],
    description: 'View run',
  },
  {
    keys: ['D'],
    description: 'Add to dataset',
  },
  {
    keys: [
      isMac ? (
        <CommandKeyIcon className="w-4" />
      ) : (
        <span className="-tracking-[0.1em]">Ctrl</span>
      ),
      <CornerDownLeftIcon className="w-4" />,
    ],
    description: 'Done with annotation',
  },
  {
    keys: ['L'],
    description: 'Next run',
  },
  {
    keys: ['H'],
    description: 'Previous run',
  },
  {
    keys: ['E'],
    description: 'Move trace to end of queue',
  },
  {
    keys: [
      isMac ? (
        <span className="text-[14px]">⌥</span>
      ) : (
        <span className="-tracking-[0.1em]">Alt</span>
      ),
      <span className="-pt-3 break-none text-center text-sm">1</span>,
      '-',
      isMac ? (
        <span className="text-[14px]">⌥</span>
      ) : (
        <span className="-tracking-[0.1em]">Alt</span>
      ),
      <span className="-pt-3 break-none text-center text-sm">9</span>,
    ],
    description: 'Focus on specific feedback',
  },
  {
    keys: [
      isMac ? (
        <CommandKeyIcon className="w-4" />
      ) : (
        <span className="-tracking-[0.1em]">Ctrl</span>
      ),
      <span className="-pt-3 text-center text-sm">/</span>,
    ],
    description: 'Show keyboard shortcuts',
  },
];

export const KEYBOARD_SHORTCUTS = {
  'annotation-queues': annotations_queue,
};
